export default "__VITE_ASSET__BEUMgkRH__"